<template>
	<v-icon
		:color="color"
		:large="large"
		:small="small"
		:x-small="xSmall"
		v-bind="mergedAttrs"
		v-on="merged_listeners"
	>
		<slot>
			{{ icon }}
		</slot>
	</v-icon>
</template>

<script>
export default {
	name: 'KIcon',
	inheritAttrs: false,
	props: {
		color: String,
		large: Boolean,
		small: Boolean,
		xSmall: Boolean,
		icon: String,
	},
	computed: {
		mergedAttrs() {
			const attrs = { ...this.$attrs }
			const isInteractive = Boolean(this.$listeners.click || attrs.role === 'button')
			if (!attrs['aria-label'] && !attrs['aria-labelledby'] && !isInteractive) {
				attrs['aria-hidden'] = attrs['aria-hidden'] ?? 'true'
				attrs.focusable = attrs.focusable ?? 'false'
			}
			return attrs
		},
		merged_listeners() {
			const listeners = { ...this.$listeners }
			if (listeners.click) {
				listeners.click = event => this.$emit('click', event)
			}
			return listeners
		}
	},
}
</script>
